/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	IAdminAuthUserResponseData,
	ILoginRequestPayload,
	IAdminLogoutData,
	IAuthStore,
} from './types';

// ==========================================:
export const initialState: IAuthStore = {
	accessToken: null,
	socketToken: null,
	isAuthenticated: false,
	loginLoader: false,
	adminLogoutLoader: false,
	email: null,
	loginEmail: null,
	loginPassword: null,
	remember: false,
	userData: null,
};

// ==========================================:
const auth = createSlice({
	name: '@@auth',
	initialState,
	reducers: {
		loginRequest: (state: IAuthStore, action: PayloadAction<ILoginRequestPayload>) => {
			const { payload } = action;
			const loginRequestState = state;

			loginRequestState.loginLoader = true;

			// if (payload.remember) {
			// 	loginRequestState.loginEmail = payload.email;
			// 	loginRequestState.loginPassword = payload.password;
			// }
		},
		loginSuccess: (state: IAuthStore, action: PayloadAction<IAdminAuthUserResponseData>) => {
			const { payload } = action;
			const loginState = state;

			loginState.isAuthenticated = true;
			loginState.loginLoader = false;
			loginState.accessToken = payload.token;
		},
		logoutRequest: (state: IAuthStore, action: PayloadAction<IAdminLogoutData>) => {
			const logoutState = state;

			logoutState.adminLogoutLoader = true;
		},
		authInitState: (state: IAuthStore) => {
			const authInitStateState = state;

			if (authInitStateState.remember) {
				authInitStateState.isAuthenticated = false;
				authInitStateState.accessToken = null;
				authInitStateState.adminLogoutLoader = false;
				authInitStateState.loginLoader = false;
			} else {
				return initialState;
			}
		},
	},
});

export default auth.reducer;
export const { loginRequest, loginSuccess, logoutRequest, authInitState } = auth.actions;
